function MorePage() {
	return <div>MorePage</div>
}

export default MorePage
